import { AnalyticsOsNameEnum } from '@parta-io/schemes/dist/modules/analytics/types/osName'
import { parseOsName } from '@parta-io/schemes/dist/modules/analytics/utils/parseOsName'

export const OS_NAME = parseOsName(window.navigator.userAgent) || AnalyticsOsNameEnum.OTHER
